import { render, staticRenderFns } from "./list_approve.vue?vue&type=template&id=5c575a33&scoped=true"
import script from "./list_approve.vue?vue&type=script&lang=js"
export * from "./list_approve.vue?vue&type=script&lang=js"
import style0 from "./list_approve.vue?vue&type=style&index=0&id=5c575a33&prod&lang=css&scoped=true"
import style1 from "./list_approve.vue?vue&type=style&index=1&id=5c575a33&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c575a33",
  null
  
)

export default component.exports